import { API_TWITTER_OAUTH2_ENDPOINT } from '.';

export async function requestTwitterLoginUrl(scope) {
  if (!scope || !Array.isArray(scope) || scope.length === 0) {
    throw new Error('scope malformated on client request');
  }

  return new Promise((resolve, reject) => {
    const data = {
      scope,
    };

    fetch(`${API_TWITTER_OAUTH2_ENDPOINT}/link`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'content-type': 'application/json',
      },
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(response.statusText);
        }
      })
      .then(data => resolve(data))
      .catch(error => {
        reject(error);
      });
  });
}

export async function generateAccessTokenAndLogin(code, state) {
  if (!code) {
    throw new Error('Twitter auth code required');
  }
  if (!state) {
    throw new Error('Twitter auth state required');
  }
  return new Promise((resolve, reject) => {
    const data = {
      code,
      state,
    };

    fetch(`${API_TWITTER_OAUTH2_ENDPOINT}/callback`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'content-type': 'application/json',
      },
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(response.statusText);
        }
      })
      .then(data => resolve(data))
      .catch(error => {
        reject(error);
      });
  });
}

export default {
  requestTwitterLoginUrl,
  generateAccessTokenAndLogin,
};
